export default "__VITE_ASSET__8f9fe4c2__"